import {GREY} from '@apps-common/ui-theme/Colors';
import {Map, TileLayer, VectorLayer} from '@planet/layers';
import GeoJSON from 'ol/format/GeoJSON';
import {fromExtent} from 'ol/geom/Polygon';
import {array, object} from 'prop-types';
import React, {Component} from 'react';
import {MAPBOX_DARK} from '../config.js';
import {getExtentForGeometry, scaleExtent} from '../util/map.js';
import {geometryStyle, getGeometryStyle} from '../util/styles.js';

const format = new GeoJSON();

class MiniMap extends Component {
  static propTypes = {
    extent: array,
    geometry: object.isRequired,
  };

  render() {
    const geometryExtent = getExtentForGeometry(this.props.geometry);
    scaleExtent(geometryExtent, 1.5);

    const view = {
      extent: geometryExtent,
    };

    let data;
    if (this.props.extent) {
      data = format.writeGeometryObject(fromExtent(this.props.extent));
    }

    return (
      <Map view={view} {...this.props}>
        <TileLayer url={MAPBOX_DARK} />
        <VectorLayer data={this.props.geometry} layerStyle={geometryStyle} />
        <VectorLayer data={data} layerStyle={getGeometryStyle(GREY[100])} />
      </Map>
    );
  }
}

export default MiniMap;
